import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MediaService, MEDIA_CATEGORIES } from '../../services/media/media.service';
import { ToastService } from '../../services/toast/toast.service';
import { LoaderComponent } from '../../atoms/loader/loader.component';

// pick an image from the media library: central media plus the establishment's own
// (data.establishmentId; null = central only). Closes with the chosen image url.
// data = { establishmentId, category?, selectedUrl? }.
@Component({
  selector: 'app-media-picker-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, LoaderComponent],
  templateUrl: './media-picker-dialog.component.html',
  styleUrls: ['./media-picker-dialog.component.scss', '../../../common-style/ac-dialog.scss'],
})
export class MediaPickerDialogComponent implements OnInit {
  media: any[] = [];
  isLoading: boolean = false;
  category = new FormControl<string>('');
  search = new FormControl('');
  selectedUrl: string = '';
  readonly categories = MEDIA_CATEGORIES;

  constructor(
    public dialogRef: MatDialogRef<MediaPickerDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { establishmentId: number | null; category?: string; selectedUrl?: string },
    private mediaService: MediaService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.category.setValue(this.data.category || '');
    this.selectedUrl = this.data.selectedUrl || '';
    this.load();
  }

  load(): void {
    this.isLoading = true;
    this.mediaService.listOptions(this.data.establishmentId, this.category.value || undefined).subscribe({
      next: (res: any) => {
        this.media = res?.data?.media || [];
        this.isLoading = false;
      },
      error: (err) => {
        this.media = [];
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to load media.');
      },
    });
  }

  filteredMedia(): any[] {
    const term = (this.search.value || '').trim().toLowerCase();
    if (!term) return this.media;
    return this.media.filter((m) => `${m.name} ${m.category}`.toLowerCase().includes(term));
  }

  placeOf(item: any): string {
    return item.scope === 'CENTRAL' ? 'Central' : item.establishmentName || 'Establishment';
  }

  select(item: any): void {
    this.selectedUrl = item.imageUrl;
  }

  use(): void {
    if (!this.selectedUrl) {
      this.toastService.error('Select an image.');
      return;
    }
    this.dialogRef.close(this.selectedUrl);
  }

  close(): void {
    this.dialogRef.close();
  }
}
